// @flow
import * as React from 'react'
import { PageShell } from 'ui/Page'
import { H4, P } from 'ui/Typography'
import Link from 'ui/Link'
import Loader from 'ui/Loader'

import './LoadingPage.module.scss'

type Props = {
  error: boolean,
  pastDelay: boolean,
}

export default class LoadingPage extends React.Component<Props> {
  render = () => {
    return <PageShell>{this.renderBody()}</PageShell>
  }

  renderBody = () => {
    if (this.props.error) return this.renderError()
    return <Loader />
  }

  renderError = () => {
    if (window.Rollbar) window.Rollbar.error('Error loading page')

    return (
      <div styleName="error">
        <P>
          <H4>Sorry, there was a problem loading the page.</H4>
        </P>
        <P>
          Please <Link onClick={() => window.location.reload(true)}>reload the page.</Link>
        </P>
      </div>
    )
  }
}
